'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { PopoverContent } from '@achra/ui/popover';
import { MetricItemFilter } from './metric-item-filter';
export type SortOptionValue = 'reporting_newest' | 'reporting_oldest' | 'modified_newest' | 'modified_oldest';
interface SortPopoverContentProps {
  metric: SortOptionValue;
  handleOnMetricSelect: (value: SortOptionValue) => void;
}
function SortPopoverContent(t0) {
  const $ = _c(31);
  const {
    metric,
    handleOnMetricSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-foreground text-sm font-semibold">Sort by</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleOnMetricSelect) {
    t2 = <div className="flex items-center justify-between px-2 pt-2 pb-1">{t1}<Button variant="ghost" onClick={() => {
        handleOnMetricSelect("modified_newest");
      }} className="text-muted-foreground hover:text-foreground text-sm transition-colors outline-none">Reset</Button></div>;
    $[1] = handleOnMetricSelect;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-muted-foreground/80 px-2 py-1.5 text-xs font-semibold">Reporting Month</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = metric === "reporting_newest";
  let t5;
  if ($[4] !== handleOnMetricSelect) {
    t5 = () => {
      handleOnMetricSelect("reporting_newest");
    };
    $[4] = handleOnMetricSelect;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <MetricItemFilter label="Newest First" isSelected={t4} onClick={t5} />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = metric === "reporting_oldest";
  let t8;
  if ($[9] !== handleOnMetricSelect) {
    t8 = () => {
      handleOnMetricSelect("reporting_oldest");
    };
    $[9] = handleOnMetricSelect;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <MetricItemFilter label="Oldest First" isSelected={t7} onClick={t8} />;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="text-muted-foreground/80 mt-2 px-2 py-1.5 text-xs font-semibold">Last Modified</div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = metric === "modified_newest";
  let t12;
  if ($[15] !== handleOnMetricSelect) {
    t12 = () => {
      handleOnMetricSelect("modified_newest");
    };
    $[15] = handleOnMetricSelect;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <MetricItemFilter label="Newest First" isSelected={t11} onClick={t12} />;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const t14 = metric === "modified_oldest";
  let t15;
  if ($[20] !== handleOnMetricSelect) {
    t15 = () => {
      handleOnMetricSelect("modified_oldest");
    };
    $[20] = handleOnMetricSelect;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t14 || $[23] !== t15) {
    t16 = <MetricItemFilter label="Oldest First" isSelected={t14} onClick={t15} />;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t13 || $[26] !== t16 || $[27] !== t2 || $[28] !== t6 || $[29] !== t9) {
    t17 = <PopoverContent className="mt-1 w-60 p-0" align="end"><div className="flex flex-col gap-1 p-2">{t2}{t3}{t6}{t9}{t10}{t13}{t16}</div></PopoverContent>;
    $[25] = t13;
    $[26] = t16;
    $[27] = t2;
    $[28] = t6;
    $[29] = t9;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
}
export { SortPopoverContent };